import { makeStyles } from "@mui/styles";
import { FONT_FAMILY } from "common/sharedFunctions.js";

const useContactStyles = makeStyles((theme) => ({
  section: {
    padding: "150px 40px",
    position: "relative",
    zIndex: 2,
  },
  container: {
    maxWidth: "1440px",
    margin: "0 auto",
    padding: "0 80px",
    color: "#FFFFFF",
    fontFamily: FONT_FAMILY,
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "48px",
    color: "#FFFFFF",
  },
  contactInfo: {
    marginBottom: "32px",
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "24px",
    "& svg": {
      width: "24px",
      height: "24px",
    },
  },
  formContainer: {
    background:
      "linear-gradient(rgba(244, 244, 244, 0.), rgba(244, 244, 244, 0.2))", // #F4F4F4 with 40% and 20% opacity
    backdropFilter: "blur(20px)",
    borderRadius: "16px",
    padding: theme.spacing(4),
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  formTitle: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "32px",
    color: "#FFFFFF",
  },
  input: {
    marginBottom: theme.spacing(3),
    "& .MuiInput-underline:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.5)",
      borderWidth: "3px",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: "rgba(255, 255, 255, 0.7)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff",
    },
    "& .MuiInputLabel-root": {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19.6px",
      letterSpacing: "0%",
      color: "#fff",
      opacity: 0.7,
    },
    "& ::placeholder": {
      color: "rgba(255, 255, 255, 0.7)",
      opacity: 1,
    },
    "& .MuiInputBase-input": {
      color: "#fff",
    },
  },
  submitButton: {
    backgroundColor: "#8B3B8B",
    width: "100%",
    padding: theme.spacing(1.5),
    fontSize: "1.1rem",
    textTransform: "none",
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: "#9D449D",
    },
  },
  gridContainer: {
    display: "flex",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
    },
  },
}));

export default useContactStyles;
